export default __webpack_public_path__ + "static/media/approved-pariuri.b95ae20b.svg";